import { FC } from 'react'

import styled from 'styled-components'

import { PrimaryRadio } from 'src/Components/PrimaryRadio'
import { variables } from 'src/Styled/variables'

const RadioContainer = styled.div<{ $checked?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  padding: 12px 16px;
  border-radius: 16px;
  border: 1px solid
    ${({ theme, $checked }) =>
      $checked ? theme.color.brandGreen : theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  width: 100%;
  max-width: 600px;
  min-width: 288px;
`

const StyledRadio = styled(PrimaryRadio)`
  margin: 0;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: ${({ theme }) => theme.color.darkGrey};
`

const OptionTitle = styled.span`
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const OptionDescription = styled.span`
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

interface AiUsageOptionProps {
  checked: boolean
  title: string
  description: string
  onClick: () => void
}

export const AiUsageOption: FC<AiUsageOptionProps> = ({
  checked,
  title,
  description,
  onClick,
}) => (
  <RadioContainer $checked={checked} onClick={onClick}>
    <StyledRadio checked={checked} />
    <TextContainer>
      <OptionTitle>{title}</OptionTitle>
      <OptionDescription>{description}</OptionDescription>
    </TextContainer>
  </RadioContainer>
)
